export default "__VITE_ASSET__B5C2pckg__"